import {request} from 'src/utils/AdminApi';
export const createFoxlineOrder = (order) => request('/foxline/orders', 'post', order);
export const getFoxlineOrderLogs = (orderId) => request(`/foxline/orders/${orderId}/logs`);
export const getFoxlineOrder = (orderId) => request('/foxline/orders/' + orderId);
